export const NONE_VALUE = 'none' as const;
